import { useTheme } from "@mui/material";
import { useGridApiRef } from "@mui/x-data-grid-premium";
import React, { useMemo } from "react";

import RoundedBorderContainer from "@/Components/v2/atoms/RoundedBorderContainer/RoundedBorderContainer";
import { useConfig } from "@/hooks/useConfig";
import { DataGrid } from "@/shared/components/DataGrid/DataGrid";
import { GeoViewToggle } from "@/shared/types";

import { useFlightingStore } from "../../store/useFlightingStore";
import { ROIDataPoint } from "../../types/common";
import { toGridColumns, toGridRows } from "../DataGrid/adapter";
import { ToolBar } from "../DataGrid/ToolBar";

interface GridContainerProps {
  title: string;
  roiData: ROIDataPoint[];
  hasGeoData: boolean;
}

export const GridContainer: React.FC<GridContainerProps> = ({ title, roiData, hasGeoData }) => {
  const theme = useTheme();
  const apiRef = useGridApiRef();
  const { config } = useConfig();
  const { geoView } = useFlightingStore((state) => state.grid);
  const { setGeoView } = useFlightingStore();

  const currencySymbol = config.currency.getSymbol();
  const formatCurrency = config.currency.formatCurrency;

  const rows = useMemo(() => toGridRows(roiData, formatCurrency), [roiData]);
  const columns = useMemo(
    () => toGridColumns(roiData, currencySymbol, geoView, hasGeoData, config),
    [roiData, geoView, hasGeoData]
  );

  const geoViewLabels = {
    [GeoViewToggle.AGGREGATE]: "Aggregate Geographies",
    [GeoViewToggle.SPLIT]: "Split by Geography",
  };

  return (
    <RoundedBorderContainer>
      <DataGrid
        apiRef={apiRef}
        theme={theme}
        rows={rows}
        columns={columns}
        sortModel={[{ field: "date", sort: "desc" }]}
        toolbarComponent={
          <ToolBar
            title={title}
            apiRef={apiRef}
            geoView={geoView}
            setGeoView={setGeoView}
            geoViewLabels={geoViewLabels}
            hasGeoData={hasGeoData}
          />
        }
      />
    </RoundedBorderContainer>
  );
};
